import { combineEpics } from 'redux-observable';

import analyticsEpic from './analytics';
import layoutsEpic from './layouts';
import listsEpic from './lists';
import podcastSearchEpic from './podcastSearch';
import publishEpic from './publish';

export default combineEpics(analyticsEpic, layoutsEpic, listsEpic, podcastSearchEpic, publishEpic);
